/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Trip List Icon component.
 */
export const TripListIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11.75' cy='10.75' r='0.5' fill={iconColor} stroke={iconColor} strokeWidth='0.5' />
      <circle cx='11.75' cy='14.75' r='0.5' fill={iconColor} stroke={iconColor} strokeWidth='0.5' />
      <circle cx='11.75' cy='18.75' r='0.5' fill={iconColor} stroke={iconColor} strokeWidth='0.5' />
      <rect x='14.375' y='10.375' width='5.25' height='0.75' rx='0.375' fill={iconColor} stroke={iconColor} strokeWidth='0.75' />
      <rect x='14.375' y='14.375' width='5.25' height='0.75' rx='0.375' fill={iconColor} stroke={iconColor} strokeWidth='0.75' />
      <rect x='14.375' y='18.375' width='5.25' height='0.75' rx='0.375' fill={iconColor} stroke={iconColor} strokeWidth='0.75' />
      <path d='M20 5.375C22.002 5.375 23.625 6.99797 23.625 9V20C23.625 22.002 22.002 23.625 20 23.625H11C8.99797 23.625 7.375 22.002 7.375 20V14.6533L7.38086 14.6475L7.375 14.6416C7.37939 14.6454 7.38086 14.6475 7.38086 14.6475L7.38184 14.6465L7.38281 14.6445C7.38281 14.6445 7.38512 14.6415 7.38672 14.6396C7.3899 14.636 7.39416 14.631 7.39941 14.625C7.41005 14.6128 7.42565 14.5959 7.44434 14.5742C7.48171 14.5309 7.53432 14.4688 7.60059 14.3906C7.73347 14.2338 7.92116 14.0096 8.14453 13.7344C8.29025 13.5548 8.45148 13.3513 8.625 13.1299V20C8.625 21.3117 9.68832 22.375 11 22.375H20C21.3117 22.375 22.375 21.3117 22.375 20V9C22.375 7.68832 21.3117 6.625 20 6.625H12.3506C12.4425 6.23245 12.5 5.82735 12.5 5.4209C12.5 5.40558 12.4991 5.39029 12.499 5.375H20Z' fill={iconColor} />
      <circle cx='5.5' cy='5.5' r='1.5' fill={iconColor} />
      <path d='M10 5.42105C10 7.86273 5.5 13 5.5 13C5.5 13 1 7.86273 1 5.42105C1 2.97937 3.01472 1 5.5 1C7.98528 1 10 2.97937 10 5.42105Z' stroke={iconColor} strokeWidth='1.25' />
    </svg>
  );
};

export default TripListIcon;
